import { formatedDateWP } from "../../lib/dateFormater";

export const removeTag = (tag) => {
  return tag.replace(/<\/?[^>]+(>|$)/g, "") || "";
};

export const singleNewsDataDeserializer = (data) => {
  if (!data?.id) {
    return null;
  }
  
  const featuredMedia = data?.["_embedded"]?.["wp:featuredmedia"]?.[0];
  const category = data?.["_embedded"]?.["wp:term"]?.[0]?.[0];
  
  return {
    id: data.id,
    title: data?.title?.rendered ? removeTag(String(data.title.rendered)) : "",
    metaDescription: data?.excerpt?.rendered ? removeTag(String(data.excerpt.rendered)) : "",
    slug: data?.slug || "",
    ogImage: featuredMedia?.source_url || "/ogImage.jpg",
    // content: removeTag(String(data?.content?.rendered)),
    content: data?.content?.rendered || "",
    category: {
      id: category?.id || "",
      name: category?.name || "",
    },
    date: data?.date ? formatedDateWP(data.date) : "",
    image: featuredMedia?.source_url || "",
    categories: data?.categories || [],
  };
};

export const newsThumbnailsDeserializer = (data) => {
  if (!data?.id) {
    return null;
  }
  
  const featuredMedia = data?.["_embedded"]?.["wp:featuredmedia"]?.[0];
  const categories = data?.["_embedded"]?.["wp:term"]?.[0]?.[0];
  
  return {
    id: data.id,
    img: featuredMedia?.source_url || "",
    imgAlt: featuredMedia?.alt_text || "about digikala",
    title: data?.title?.rendered ? removeTag(String(data.title.rendered)) : "",
    catTitle: categories?.name || "",
    date: data?.date ? formatedDateWP(data.date) : "",
    duration: undefined,
    slug: data?.slug || "",
    link: data?.slug ? `/newsroom/${data.slug}` : "/404",
  };
};
